module.exports = __webpack_public_path__ + "2cf3dd47aef64fcd60e1d7dd5d7394ed.svg";